/* eslint-disable use-safe-translation/enforce-use-safe-translation */
import type {ReactElement} from 'react'
import moment from 'moment-timezone'
import {Trans} from 'react-i18next'
import type {TranslateT} from '@freckle/educator-entities/ts/common/helpers/translate'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import type {RosterSyncEventT} from '@freckle/school/ts/common/models/summary'
import type {RosterSyncedByT} from '@freckle/school/ts/common/models/summary'
import {syncBar, lastSyncBy} from './sync-bar.module.scss'

type Props = {
  mostRecentRosterSyncEvent: RosterSyncEventT
}

export default function SyncBar(props: Props): ReactElement | null {
  const {mostRecentRosterSyncEvent} = props
  const {t} = useSafeTranslation()

  const syncByStr = getSyncedByStr(t, mostRecentRosterSyncEvent.syncedBy)
  const lastSyncedAt = moment(mostRecentRosterSyncEvent.createdAt)

  return (
    <div className={syncBar}>
      <div>
        <Trans
          i18nKey="MANAGE_TEACHERS_ROSTERING_BAR_SYNC_BAR_LAST_SYNCED"
          values={{lastSyncedAt}}
        />
      </div>
      <div className={lastSyncBy}>{syncByStr}</div>
    </div>
  )
}

function getSyncedByStr(t: TranslateT, syncedBy: RosterSyncedByT): string {
  switch (syncedBy.tag) {
    case 'idp':
      const {contents} = syncedBy
      return t('MANAGE_TEACHERS_ROSTERING_BAR_SYNC_BAR_SYNCED_BY_IDP_NAME', {idp: contents})
    case 'school_admin':
      const {firstName, lastName} = syncedBy.contents
      return t('MANAGE_TEACHERS_ROSTERING_BAR_SYNC_BAR_SYNCED_BY_CSV_UPLOAD', {firstName, lastName})
    case 'console_agent':
    case 'impersonation':
      return t('MANAGE_TEACHERS_ROSTERING_BAR_SYNC_BAR_SYNCED_BY_FRECKLE')
    default:
      throw new Error(`Invalid tag ${(syncedBy as {tag: never}).tag}`)
  }
}
